import { render } from "./X62.vue?vue&type=template&id=b5a70c2c"
import script from "./X62.vue?vue&type=script&lang=js"
export * from "./X62.vue?vue&type=script&lang=js"

import "./X62.vue?vue&type=style&index=0&id=b5a70c2c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__